import React, { useEffect, useCallback, useState, useMemo } from 'react'
import { images } from '../../assets'
import { addAciveClass } from '../tools'
import { commonConfig } from '../configs'
import AirDatepicker from 'air-datepicker'
import localeKo from 'air-datepicker/locale/ko'
import * as dayjs from 'dayjs'

const ServiceList = ({
  isSpgeCF,
  isNormal2Premium,
  register,
  serviceNum,
  setServiceNum,
  cost,
  setCost,
  setServiceInfo,
  serviceInfo,
  serviceBoxInputEvh,
  setServiceHelper,
  serviceHelper,
  freeMonthYn,
  setServiceStartDt,
  setWithdrawalDt,
  withdrawalDt,
  serviceStartDt,
  bizNo,
  isTargetManager,
  isServiceManager
}) => {
  useEffect(() => {
    getServiceList()
    dateSetting()
  }, [])

  useEffect(() => {
    let maxdate = new Date()
    let this_month = dayjs().daysInMonth() - dayjs().format('DD') // 이번달 남은 일수
    let next_month = dayjs().add(0, 'month').daysInMonth() // 다음달 총 일수
    maxdate.setDate(maxdate.getDate() + this_month + next_month - 1)

    new AirDatepicker('#select_service_start_dt', {
      dateFormat: 'yyyy.MM.dd',
      locale: localeKo,
      autoClose: true,
      position: 'bottom right',
      minDate: dayjs().add(1, 'day'),
      maxDate: maxdate,
      onSelect: date => {
        dateSetting(date.formattedDate)
      }
    })
  }, [])

  useEffect(() => {
    init()
  }, [bizNo])

  const init = () => {
    let startData = dayjs().add(1, 'day').format('YYYY.MM.DD')
    let withdrawalData = dayjs().add(1, 'day').add(2, 'month').format('YYYY.MM.01')
    setServiceStartDt(startData)
    document.getElementById('select_service_start_dt').value = startData
    setWithdrawalDt(withdrawalData)
    setServiceData([])
    setServiceNum(0)
  }

  const dateSetting = data => {
    if (data) {
      setServiceStartDt(data)
      data = data.replaceAll('.', '-')
      let newStartData = dayjs(data).add(2, 'month').format('YYYY.MM.01')
      setWithdrawalDt(newStartData)
    } else {
      let startData = dayjs().add(1, 'day').format('YYYY.MM.DD')
      let withdrawalData = dayjs().add(1, 'day').add(2, 'month').format('YYYY.MM.01')
      setServiceStartDt(startData)
      document.getElementById('select_service_start_dt').value = startData
      setWithdrawalDt(withdrawalData)
    }
  }

  const costSetting = () => {
    if (serviceNum === 0) {
      setCost(0)
    } else if (serviceNum === 1) {
      setCost(40000)
    } else {
      setCost(40000 + (serviceNum - 1) * 10000)
    }
  }

  useEffect(() => {
    costSetting()
  }, [serviceNum])

  const [serviceList, setServiceList] = useState() // 목록
  // const [serviceData, setServiceData] = useState([
  //   // "code": "01" 배달의민족
  //   // "code": "02" 요기요
  //   // "code": "03" 쿠팡이츠
  //   // { app_type_code: '01', app_id: '아이디', app_password: '비밀번호' },
  //   // { app_type_code: '02', app_id: '아이디', app_password: '비밀번호' },
  //   // { app_type_code: '03', app_id: '아이디', app_password: '비밀번호' },
  // ]) // 댓글 목록

  // useEffect(() => {
  //   setServiceInfo(serviceData)
  // }, [serviceData])
  const setServiceData = d => setServiceInfo(d)
  const serviceData = serviceInfo

  const getServiceList = useCallback(data => {
    data = {
      parent_code: 'app_type_code'
    }
    commonConfig
      .getCodeList(data)
      .then(result => {
        setServiceList(result)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  function isIdFind(e, id) {
    if (e.app_type_code === id) {
      return true
    }
  }

  const inputId = (e, id) => {
    const dataId = serviceData?.find(e => isIdFind(e, id))
    if (dataId) {
      dataId.app_id = e?.target.value
    }
    // setServiceData(serviceData.map((i, data) => (serviceData.app_type_code[id].app_id = event.target.value)))
  }

  const inputPassword = (e, id) => {
    const dataPassword = serviceData?.find(e => isIdFind(e, id))
    if (dataPassword) {
      dataPassword.app_password = e?.target.value
    }
  }

  const EmptySpace = () => {
    return <span style={{ visibility: 'hidden' }}>0</span>
  }

  return (
    <div id="service-app-area" className={`service_wrap  ${isServiceManager ? 'service_manager' : ''}`}>
      <p className="wrap_tit service-app-tit">
        서비스 신청 정보<span className="color_r">*</span>
      </p>
      {/*<p className="service_subtit">채널 1개 기본 40,000원, 기타 추가 건당 10,000원이 부과됩니다.</p>*/}

      {serviceList ? (
        serviceList?.data.map((item, i) => (
          <div id={'sevice-box-' + item?.code} className="dlvr-app-box service_box" key={`serviceList_${i}`}>
            <div className="service_check">
              <label htmlFor={`${item?.code}`}>
                <div className="service_logo">
                  <Img code={item.code} />
                  <p>{item?.code_description}</p>
                </div>
              </label>
              <input
                style={{ scale: 0 }}
                type="checkbox"
                name="service_division"
                id={`${item?.code}`}
                onChange={e => serviceBoxInputEvh(e, item?.code)}
                autoComplete="off"
              />
              <label className="label_img" htmlFor={`${item?.code}`}></label>
            </div>
            <div className="service_account">
              <label htmlFor={`service_id_${item?.code}`}>아이디</label>
              <input
                type="text"
                name={`service_id_${item?.code}`}
                id={`service_id_${item?.code}`}
                onChange={e => inputId(e, item?.code)}
                autoComplete="off"
                readOnly={isNormal2Premium}
              />
              <label htmlFor={`service_password_${item?.code}`}>비밀번호</label>
              <input
                type="password"
                name={`service_password_${item?.code}`}
                id={`service_password_${item?.code}`}
                onChange={e => inputPassword(e, item?.code)}
                autoComplete="off"
                readOnly={isNormal2Premium}
              />
            </div>
          </div>
        ))
      ) : (
        // TODO 신청 가능한 서비스가 없을때 디자인 or 프로세스가 필요한지 확인필요
        <div className="empty_text_wrap">신청 가능한 서비스가 없습니다.</div>
      )}

      <div className={'service_box preview date_wrap ' + (isSpgeCF ? 'display_none' : '')}>
        <div>
          <div className="service_tooltip">
            <p>시작예정일</p>
            <p className="tooltip" onClick={addAciveClass}></p>
            <div className="tooltip_text">시작예정일에 신청하신 계정으로 신청일자부터 등록된 리뷰가 수집되고 사장님 댓글이 관리됩니다.</div>
          </div>
          {/*<p className="bold service_date">{tempServiceStartDt}</p>*/}
          <p className="bold service_date data_picker_wrap">
            <input
              {...register('select_service_start_dt')}
              type="text"
              readOnly={true}
              name="select_service_start_dt"
              id="select_service_start_dt"
              autoComplete="off"
              className={freeMonthYn ? '' : 'display_none'}
            />

            <span className={freeMonthYn ? 'display_none' : ''}>{serviceStartDt}</span>
            {/*{freeMonthYn ? (*/}
            {/*  <input*/}
            {/*    {...register('select_service_start_dt')}*/}
            {/*    type="text"*/}
            {/*    readOnly={true}*/}
            {/*    name="select_service_start_dt"*/}
            {/*    id="select_service_start_dt"*/}
            {/*    autoComplete="off"*/}
            {/*  />*/}
            {/*) : (*/}
            {/*  <>{serviceStartDt}</>*/}
            {/*)}*/}
          </p>
        </div>
        {!isServiceManager && (
          <div>
            <div className="service_tooltip">
              <p>출금예정일</p>
            </div>
            <p className="bold service_date">{withdrawalDt}</p>
          </div>
        )}
      </div>

      {!isSpgeCF &&
        !isServiceManager &&
        (isTargetManager ? (
          <div className="tartget_manager_notice">
            <div className="promotion_top">
              <img src={images.promotion_title} alt="스폰지R 프로모션 타이틀" />
              <img src={images.promotion_sub} alt="스폰지R 프로모션 서브타이틀" />
            </div>
            <div className="service_box preview date_wrap">
              <div>
                <div className="service_tooltip" style={{ width: 50 + '%', paddingLeft: 14 + '%', textAlign: 'center' }}>
                  <p>리뷰 개수 (월) </p>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p>서비스 비용 (원)</p>
                </div>
              </div>
              <div style={{ width: 100 + '%' }}>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <div className="service_date flex" style={{ marginBottom: '4px' }}>
                    <div className="hidden">000</div>
                    <div>~</div>
                    <div>
                      <EmptySpace />
                      30
                    </div>
                  </div>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p className="bold service_date delete">10,000</p>
                </div>
              </div>
              <div style={{ width: 100 + '%' }}>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <div className="service_date flex" style={{ marginBottom: '4px' }}>
                    <div>
                      31
                      <EmptySpace />
                    </div>
                    <div>~</div>
                    <div>
                      <EmptySpace />
                      60
                    </div>
                  </div>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p className="bold service_date delete">20,000</p>
                </div>
              </div>
              <div style={{ width: 100 + '%' }}>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <div className="service_date flex" style={{ marginBottom: '4px' }}>
                    <div>
                      61
                      <EmptySpace />
                    </div>
                    <div>~</div>
                    <div>120</div>
                  </div>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p className="bold service_date delete">30,000</p>
                </div>
              </div>
              <div style={{ width: 100 + '%' }}>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <div className="service_date flex" style={{ marginBottom: '4px' }}>
                    <div>121</div>
                    <div>~</div>
                    <div>300</div>
                  </div>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p className="bold service_date delete">40,000</p>
                </div>
              </div>
              <div style={{ width: 100 + '%' }}>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <div className="service_date flex" style={{ marginBottom: '4px' }}>
                    <div>301</div>
                    <div>~</div>
                    <div>450</div>
                  </div>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p className="bold service_date delete">50,000</p>
                </div>
              </div>
              <div style={{ width: 100 + '%' }}>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <div className="service_date flex" style={{ marginBottom: '4px' }}>
                    <div>451</div>
                    <div>~</div>
                    <div className="hidden">000</div>
                  </div>
                </div>
                <div style={{ width: 50 + '%', textAlign: 'center' }}>
                  <p className="bold service_date delete">60,000</p>
                </div>
              </div>
            </div>
            <div className="promotion_bottom">
              <img src={images.promotion_content} alt="스폰지R 프로모션 내용" />
            </div>
          </div>
        ) : (
          <div className="service_box preview date_wrap">
            <div>
              <div className="service_tooltip" style={{ width: 50 + '%', paddingLeft: 14 + '%', textAlign: 'center' }}>
                <p>리뷰 개수 (월) </p>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p>서비스 비용 (원)</p>
              </div>
            </div>
            <div style={{ width: 100 + '%' }}>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <div className="service_date flex" style={{ marginBottom: '4px' }}>
                  <div className="hidden">000</div>
                  <div>~</div>
                  <div>
                    <EmptySpace />
                    30
                  </div>
                </div>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p className="bold service_date">10,000</p>
              </div>
            </div>
            <div style={{ width: 100 + '%' }}>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <div className="service_date flex" style={{ marginBottom: '4px' }}>
                  <div>
                    31
                    <EmptySpace />
                  </div>
                  <div>~</div>
                  <div>
                    <EmptySpace />
                    60
                  </div>
                </div>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p className="bold service_date">20,000</p>
              </div>
            </div>
            <div style={{ width: 100 + '%' }}>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <div className="service_date flex" style={{ marginBottom: '4px' }}>
                  <div>
                    61
                    <EmptySpace />
                  </div>
                  <div>~</div>
                  <div>120</div>
                </div>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p className="bold service_date">30,000</p>
              </div>
            </div>
            <div style={{ width: 100 + '%' }}>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <div className="service_date flex" style={{ marginBottom: '4px' }}>
                  <div>121</div>
                  <div>~</div>
                  <div>300</div>
                </div>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p className="bold service_date">40,000</p>
              </div>
            </div>
            <div style={{ width: 100 + '%' }}>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <div className="service_date flex" style={{ marginBottom: '4px' }}>
                  <div>301</div>
                  <div>~</div>
                  <div>450</div>
                </div>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p className="bold service_date">50,000</p>
              </div>
            </div>
            <div style={{ width: 100 + '%' }}>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <div className="service_date flex" style={{ marginBottom: '4px' }}>
                  <div>451</div>
                  <div>~</div>
                  <div className="hidden">000</div>
                </div>
              </div>
              <div style={{ width: 50 + '%', textAlign: 'center' }}>
                <p className="bold service_date">60,000</p>
              </div>
            </div>
          </div>
        ))}

      <div className="color_r">{serviceHelper}</div>
    </div>
  )
}

export { ServiceList }

const Img = ({ code }) => {
  switch (code) {
    case '01':
      return <img src={images.logoBaemin} alt="logoBaemin" />
    case '02':
      return <img src={images.logoYogiyo} alt="logoYogiyo" />
    case '03':
      return <img src={images.logoCoupang} alt="logoCoupang" />
    default:
      return
  }
}
